import { combineReducers } from "@reduxjs/toolkit"
import authReducer from "./auth/authSlice"
import sessionExpiredReducer from "./auth/sessionExpiredSlice"
import authErrorReducer from "./auth/authErrorSlice"
import edocumentsReducer from './e-documents/edocumentsSlice'
import userReducer from "./user"
import subscriptionReducer from "./subscription"
import subscriptionBuilderReducer from "./subscription/subscriptionBuilderSlice"
import messengerReducer from "./messenger"
import otherReducer from "./other"
import managerReducer from "./manager"
import taxReducer from "./tax"
import dashboardReducer from "./dashboard"
import declarationsReducre from "./declarations"
import dueDatesReducer from "./dueDates"
import profileReducer from "./profile"
import thresholdsReducer from "./thresholds"
import transactionsReducer from "./transactions"
import registrationReducer from "./registration"
import messagesReducer from "./messages"
import taxSettingsReducer from "./tax-settings"
import merchSettingsReducer from "./merch-settings"
import websitesReducer from "./websites"
import paymentReducer from "./payment"
import documentsReducer from "./documents"
import ukSettingsReducer from "./uk-settings"
import lookUpReducer from "./look-up"
import customersReducer from "./customers"
import invoiceReportsReducer from "./invoice-reports"
import loadingReducer from "./loading/loadingSlice"
import eprNewArchitectureReducer from "./epr-new-architecture"
import authorizeProductsReducer from "./authorize-products"
import labelSettingsReducer from "./label-settings"
import invitationReducer from "./invitation"
import eprGuidesReducer from "./epr-guides"
import registrationTrackerReducer from "./registration-tracker"
import notificationCenterReducer from "./notification-center"
import clientNotificationCenterReducer from "./client-notification-center"
import sandboxReducer from "containers/ProductSettingsPage/Sandbox/model/sandboxSlice"

import { logout } from "./auth/authSlice"
import uploadDocumentsReducer from "./uploadDocuments"

const appReducer = combineReducers({
	auth: authReducer,
	sessionExpired: sessionExpiredReducer,
	authError: authErrorReducer,
	user: userReducer,
	subscription: subscriptionReducer,
	subscriptionBuilder: subscriptionBuilderReducer,
	messenger: messengerReducer,
	other: otherReducer,
	manager: managerReducer,
	tax: taxReducer,
	dashboard: dashboardReducer,
	declarations: declarationsReducre,
	dueDates: dueDatesReducer,
	profile: profileReducer,
	thresholds: thresholdsReducer,
	transactions: transactionsReducer,
	vatRegistration: registrationReducer,
	messages: messagesReducer,
	taxSettings: taxSettingsReducer,
	merchSettings: merchSettingsReducer,
	websites: websitesReducer,
	payment: paymentReducer,
	documents: documentsReducer,
	edocuments: edocumentsReducer,
	ukSettings: ukSettingsReducer,
	lookUp: lookUpReducer,
	customers: customersReducer,
	invoiceReports: invoiceReportsReducer,
	eprNewArchitecture: eprNewArchitectureReducer,
	authorizeProducts: authorizeProductsReducer,
	labelSettings: labelSettingsReducer,
	loading: loadingReducer,
	uploadDocuments: uploadDocumentsReducer,
	invitation: invitationReducer,
	eprGuides: eprGuidesReducer,
	registrationTracker: registrationTrackerReducer,
	notificationCenter: notificationCenterReducer,
	clientNotificationCenter: clientNotificationCenterReducer,
	sandbox: sandboxReducer,
})

// Root reducer that resets state on logout or reset action
const rootReducer = (state, action) => {
	// Reset entire state tree when logout is fulfilled or RESET_STORE action is dispatched
	if (logout.fulfilled.match(action) || action.type === 'RESET_STORE') {
		// Return undefined to reset all reducers to their initial state
		// This will clear all form data, user data, and other state
		state = undefined;
	}
	
	return appReducer(state, action);
}

export default rootReducer
